export enum CameraStatusDetailsType {
  WEB_UPLOAD_NOT_COMPLETE = 'WEB_UPLOAD_NOT_COMPLETE'
}